<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="手工新增费用--选择订单指令"
  >
    <div class="dialog-content">
      <el-row type="flex">
        <el-col :span="6" style="display: flex; align-items: center">
          <div>订单编号</div>
          <el-input
            placeholder="请输入内容"
            size="mini"
            style="width: 60%; margin-left: 10px"
            disabled
            v-model="selectInstructionDetailList[0].orderCode"
          >
          </el-input>
        </el-col>
        <!-- <el-col :span="6" style="display: flex; align-items: center">
          <div>订单指令编号</div>
          <el-input
            placeholder="请输入内容"
            size="mini"
            style="width: 60%; margin-left: 10px"
            disabled
            v-model="selectInstructionDetailList[0].instructCode"
          >
          </el-input>
        </el-col>
        <el-col :span="6" style="display: flex; align-items: center">
          <div style="margin: 0 10px 0 20px">服务类型</div>
          <el-input
            placeholder="请输入内容"
            size="mini"
            style="width: 60%; margin-left: 10px"
            disabled
            v-model="selectInstructionDetailList[0].orderServiceTypeName"
          >
          </el-input>
        </el-col> -->
        <el-col :span="4" style="display: flex; align-items: center">
          <div style="margin: 0 10px 0 20px">异常费用</div>
          <el-checkbox
            v-model="surchargeStatus"
            @change="(val) => changeHandler(val)"
          ></el-checkbox>
        </el-col>
      </el-row>

      <div class="main-content">
        <div v-if="!surchargeStatus"
          ><el-row type="flex" style="margin: 0 0 10px 0">
            <el-col :span="6" style="display: flex; align-items: center">
              <div>订单指令编号</div>
              <el-input
                placeholder="请输入内容"
                size="mini"
                style="width: 60%; margin-left: 10px"
                disabled
                v-model="selectInstructionDetailList[0].instructCode"
              >
              </el-input>
            </el-col>
            <el-col :span="6" style="display: flex; align-items: center">
              <div style="margin: 0 10px 0 20px">服务类型</div>
              <el-input
                placeholder="请输入内容"
                size="mini"
                style="width: 60%; margin-left: 10px"
                disabled
                v-model="selectInstructionDetailList[0].orderServiceTypeName"
              >
              </el-input>
            </el-col>
          </el-row>
          <NoSurchargeRow
            ref="NoSurchargeRow"
            :selectInstructionDetailList="selectInstructionDetailList"
          />
        </div>
        <div v-if="surchargeStatus">
          <SurchargeRow
            ref="SurchargeRow"
            :unusualList="unusualList"
            @selectionRowHandler="selectionRowHandler"
          />
          <SurchargeRowInfo
            v-if="currentSettleAccountRowData"
            ref="SurchargeRowInfo"
            @closeEditTableHandler="closeDetailEditTableHandler"
            :expenseList="expenseList"
            :tableDataList="currentSettleAccountDetailList"
            :currentSettleAccountRowData="currentSettleAccountRowData"
            :selectInstructionDetailList="selectInstructionDetailList"
            @deleteTableHandler="deleteTableDetailHandler"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="refreshHandler">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="AddExpenseHandler"
          >确认新增</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  import NoSurchargeRow from './components/NoSurchargeRow/index.vue';
  import SurchargeRow from './components/SurchargeRow/index.vue';
  import SurchargeRowInfo from './components/SurchargeRowInfo/index.vue';
  // , tableList
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';

  export default {
    components: {
      NoSurchargeRow,
      SurchargeRow,
      SurchargeRowInfo,
    },
    props: {},
    data() {
      return {
        load: false,

        columnList: defaultTableColumn,

        visible: false,
        selectInstructionDetailList: [],
        surchargeStatus: false,
        // unusualList: tableList,
        unusualList: [],
        expenseList: [],
        currentSettleAccountRowData: null, // 当前选中的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: [], //明细表数据
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      // this.getTableData();
    },
    methods: {
      openDialog() {
        this.visible = true;
        // this.getTableData();
      },
      changeHandler(val) {
        if (val) {
          this.getTableData();
          this.currentSettleAccountRowData = null;
        }
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        console.log(rowData, 'rowData');
        let { orderExceptionExpenses } = rowData;
        if (orderExceptionExpenses && orderExceptionExpenses.length) {
          this.expenseList = [];
          orderExceptionExpenses.map((item) => {
            this.expenseList.push({
              label: item.expenseName,
              value: item.expenseType,
              // value: +index + 1,
              disabled: false,
            });
          });
        }
        this.currentSettleAccountRowData = rowData;
        const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowData._XID);
        console.log(currentSettleAccountDetailList, 'currentSettleAccountDetailList');
        this.currentSettleAccountDetailList = currentSettleAccountDetailList
          ? currentSettleAccountDetailList
          : [];
        console.log(
          currentSettleAccountDetailList,
          '--选择行切换数据',
          this.settleAccountsDetailMap
        );
      },
      // 删除明细行
      deleteTableDetailHandler(rowIdList) {
        console.log(rowIdList, '删除明细', this.settleAccountsDetailMap);
        // 获取当当前数组项目
        const detailListItem = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        console.log(detailListItem, '删除前');
        // 删除子项
        const newData = detailListItem.filter((item) => !rowIdList.includes(item._XID));
        console.log(newData, '???删除后');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, newData);
      },
      // 关闭明细表的时候
      closeDetailEditTableHandler(tableData) {
        console.log(tableData, '监听明细中');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, tableData);
        console.log(this.settleAccountsDetailMap, '明细中', this.currentSettleAccountRowData._XID);
      },

      // 获取表格数据
      async getTableData() {
        let postData = {
          orderCode: this.selectInstructionDetailList[0].orderCode,
          showExpense: 1,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.ORDEREXCEPTION_QUERY_API,
          postData
        );
        if (data.code == 0) {
          this.unusualList = data.data;
        }
        // this.tableData = data?.data?.records;
        // this.tableData = tableList;
        // this.multipleSelection = []; //初始化选中数据
        // this.$refs.siruiTable.setPageTotal(data?.data?.total);
      },
      //确认新增
      async AddExpenseHandler() {
        if (
          this.surchargeStatus &&
          this.currentSettleAccountRowData &&
          this.$refs.SurchargeRowInfo.getTableData().length
        ) {
          let checkStatus = await this.$refs?.SurchargeRowInfo?.validAllEvent();
          if (checkStatus) {
            return;
          }
          let postData = this._formatSettleAccountDto();
          console.log(postData, 'postData');
          this.saveHandler(postData);
        } else if (!this.surchargeStatus && this.$refs.NoSurchargeRow.getTableData().length) {
          let checkStatus = await this.$refs?.NoSurchargeRow?.validAllEvent();
          if (checkStatus) {
            return;
          }
          let postData = this.$refs.NoSurchargeRow.getTableData();
          this.saveHandler(postData);
          console.log(
            this.$refs.NoSurchargeRow.getTableData(),
            'this.$refs.NoSurchargeRow.getTableData()'
          );
        } else {
          this.refreshHandler();
        }
      },
      refreshHandler(isSuccess = false) {
        this.surchargeStatus = false;
        this.currentSettleAccountRowData = null;
        this.visible = false;
        if (isSuccess) {
          this.$emit('AddExpenseHandler');
        }
      },
      async saveHandler(postData) {
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.RECEIVABLESEXPENSE_SAVE,
          postData
        );
        console.log(data, '提交结果');
        if (data.code == 0) {
          this.$message.success('操作成功！');
          this.refreshHandler(true);
        } else {
          this.$alert(`${data.msg}`);
        }
      },
      // 组装结算行结算明细数据给后端
      _formatSettleAccountDto() {
        let settleAccountList = [];
        let settleAccountsRowList = this.$refs.SurchargeRow.getTableData();
        settleAccountsRowList.map((item) => {
          const lineDetails = this.settleAccountsDetailMap.get(item._XID);
          settleAccountList = settleAccountList.concat(lineDetails ? lineDetails : []);
        });
        return settleAccountList;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
  .main-content {
    margin-top: 20px;
    border-top: 1px solid #ccc;
    padding-top: 15px;
  }
</style>
